module.exports = __webpack_public_path__ + "static/media/exterminador_o.6ee9479e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/exterminador_o.png
// module id = 1155
// module chunks = 0